import { MappedAnchorLine } from '../../../types/utils';

// helper to split an array into two and join each chunk as a highlight range
const splitInTwos = (lines: number[]) => {
  const acc = [];
  for (let i = 0; i < lines.length; i += 2) {
    const chunk = lines.slice(i, i + 2).join('-');
    acc.push(chunk);
  }
  return acc;
};

// This function will go through the mapped anchors and create a highlight array for the anchor
export const getHighlightFromAnchors = (
  anchor: string,
  mappedAnchors: MappedAnchorLine[],
  file: number,
): string[] => {
  const anchorLines = mappedAnchors.reduce(
    (acc: number[], { highlight, lineNumber, file: anchorFile }) => {
      if (file === anchorFile && anchor.match(new RegExp(`^${highlight}$`))) {
        return [...acc, lineNumber];
      }
      return acc;
    },
    [],
  );

  return splitInTwos(anchorLines);
};
